const getters = {
  user: state => state.user,
  settings: state => state.settings,
}
export default getters
